import { FormHelperText, ListItemText, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { isEmpty } from "lodash";
import PropTypes, {
  arrayOf,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { forwardRef, memo } from "react";
import MuiCheckbox from "./Checkbox";

const MUISelect = forwardRef(function MUISelect(
  {
    value,
    onChange,
    label,
    variant,
    options,
    error,
    size,
    sx,
    enableCheckbox,
    multiple,
    renderValue,
    disabled,
    inputAdornment,
    required,
    menuProps,
  },

  ref
) {
  const isValueInOptions =
    options && options.some((option) => option.value === value);
  return (
    <FormControl
      fullWidth
      variant={variant}
      error={!isEmpty(error)}
      size={size}
    >
      <InputLabel id="simple-select">
        {label || ""}
        {required ? (
          <Typography component={"span"} sx={{ color: "color.aigColor42" }}>
            {" "}
            *
          </Typography>
        ) : (
          ""
        )}
      </InputLabel>
      <Select
        labelId="simple-select"
        value={value || ""}
        label={required ? `${label}*` : label}
        onChange={onChange}
        inputRef={ref}
        sx={{ borderRadius: "0.5rem", ...sx }}
        renderValue={(selected) => {
          if (renderValue) {
            return renderValue(selected);
          }
          if (multiple && Array.isArray(selected)) {
            return selected
              .map(
                (val) => options.find((option) => option.value === val)?.label
              )
              .filter(Boolean)
              .join(", ");
          }
          return (
            options?.find((option) => option.value === selected)?.label ||
            selected
          );
        }}
        multiple={multiple}
        startAdornment={inputAdornment}
        disabled={disabled}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: "25rem",
              borderRadius: "0.75rem !important",
            },
          },
          disableAutoFocusItem: true,
          ...menuProps,
        }}
      >
        {options &&
          options?.map((menuItem) => (
            <MenuItem sx={{ mx: 2 }} key={menuItem?.id} value={menuItem.value}>
              {enableCheckbox ? (
                <>
                  <MuiCheckbox
                    onChange={() => {}}
                    key={menuItem?.id}
                    checked={value.indexOf(menuItem.value) > -1}
                  />
                  <ListItemText primary={menuItem.label} />
                </>
              ) : (
                <> {menuItem?.label}</>
              )}
            </MenuItem>
          ))}

        {options === null && (
          <MenuItem key="0" disabled={true}>
            No Data Found
          </MenuItem>
        )}
      </Select>
      <FormHelperText>{error?.message || ""}</FormHelperText>
    </FormControl>
  );
});

MUISelect.propTypes = {
  error: PropTypes.object,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: arrayOf(
    shape({
      id: oneOfType([string, number]),
      label: string,
      value: oneOfType([string, number]),
    })
  ),
  size: PropTypes.string,
  sx: PropTypes.object,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
  enableCheckbox: PropTypes.bool,
  multiple: PropTypes.bool,
  renderValue: PropTypes.func,
  disabled: PropTypes.bool,
  inputAdornment: PropTypes.object,
  required: PropTypes.bool,
  menuProps: PropTypes.object,
};

MUISelect.defaultProps = {
  size: "",
  enableCheckbox: false,
  multiple: false,
  disabled: false,
  required: false,
};

export default memo(MUISelect);
